<template lang="html">
	<div class="pcb">
		<div>
			<div class="topbg">
				<img src="../../assets/image/pcb/pcbpic.jpg" alt="">
			</div>
			<div class="content">
				<!--如果你也面临这个问题-->
				<div class="partone">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_01.png" alt="">
					</div>
					<div class="partoneinfos partbox">
						<img src="../../assets/image/pcb/partone_pic.png" alt="">
					</div>
				</div>
				<!--适合人群-->
				<div class="parttwo">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_02.png" alt="">
					</div>
					<div class="parttwoinfos partbox">
						<ul>
							<li>
								<div class="tit_img">
									<img src="../../assets/image/pcb/onetit.png" alt="">
								</div>
								<div class="tit_words">
									<img src="../../assets/image/pcb/parttwo_pic1.png" alt="">
									<span>
										通过学习帮助小白快速建立产品设计思维，获得PCB设计技能基本功，
										掌握PCB设计流程和方法，学会Allegro全流程PCB设计基本使用，
										独立设计多种产品练习板和FPGA高速多层PCB设计。
									</span>
								</div>
							</li>
							<li>
								<div class="tit_img">
									<img src="../../assets/image/pcb/twotit.png" alt="">
								</div>
								<div class="tit_words">
									<span>
										运用DFM设计思想，在视频手把手带学下完成一款多层单板的PCB实战设计，
										帮助初学者了解生产工艺知识，掌握从封装建库到约束规则设置，
										从布局布线到最终生产交付的PCB设计流程和方法，学会高端设计软件Allegro全流程PCB设计基本使用，
										并在专家指导下独立设计多种产品类型的练习板，助力小白从陌生到熟练、增长设计经验，
										从而获得打开PCB设计行业大门的金钥匙。
									</span>
									<img src="../../assets/image/pcb/parttwo_pic2.png" alt="">
								</div>
							</li>
							<div style="clear: both"></div>
						</ul>
					</div>
				</div>
				<!--四大优势-->
				<div class="partthree">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_03.png" alt="">
					</div>
					<div class="partthreeinfos partbox">
						<div class="partthree_left">
							<img src="../../assets/image/pcb/partthree_pic.png" alt="">
						</div>
						<div class="partthree_right">
							<div class="threeright_info">
								<div><em>01</em></div>
								<div>
									<span>深入知识点</span>
									<p>学习先进前沿技术</p>
								</div>
							</div>
							<div class="threeright_info">
								<div><em>02</em></div>
								<div>
									<span>专业的指导</span>
									<p>设计细节一网打尽</p>
								</div>
							</div>
							<div class="threeright_info">
								<div><em>03</em></div>
								<div>
									<span>内容更详尽</span>
									<p>规范高效操作技巧</p>
								</div>
							</div>
							<div class="threeright_info">
								<div><em>04</em></div>
								<div>
									<span>掌握新技能</span>
									<p>学完即可独立作业</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--相信新手-->
				<div class="partfour">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_04.png" alt="">
					</div>
					<div class="partfourinfos partbox">
						<img src="../../assets/image/pcb/partfour_pic1.png" alt="">
						<img src="../../assets/image/pcb/partfour_pic2.png" alt="">
						<img src="../../assets/image/pcb/partfour_pic3.png" alt="">
						<img src="../../assets/image/pcb/partfour_pic4.png" alt="">
					</div>
				</div>
				<!--课程大纲-->
				<div class="partfive">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_05.png" alt="">
					</div>
					<div class="partfiveinfos partbox">
						<div class="partfive_box">
							<div><img src="../../assets/image/pcb/partfive_pic1.png" alt=""></div>
							<div>
								<p>入门带学</p>
								<ul>
									<li><i></i>PCB设计基础</li>
									<li><i></i>软件实操</li>
									<li><i></i>高速PCB入门</li>
									<li><i></i>PCB设计生产流程</li>
								</ul>
							</div>
						</div>
						<div class="partfive_box">
							<div><img src="../../assets/image/pcb/partfive_pic1.png" alt=""></div>
							<div>
								<p>进阶实操</p>
								<span>FPGA高速多层PCB设计实践</span>
								<ul>
									<li><i></i>原理图解读及设计规划-兵马未动粮草先行</li>
									<li><i></i>布局思路与布局实战-思路决定出路</li>
									<li><i></i>高速约束规则制定与设置-国有国法，家有家规</li>
									<li><i></i>DDR模块设计实战-明知山有虎，偏向虎山行</li>
									<li><i></i>考虑SI、EMC的接口模块设计-打铁还需自身硬</li>
									<li><i></i>高速信号、电源仿真验证-大胆假设，小心求证</li>
									<li><i></i>设计高手养成记-路漫漫其修远兮</li>
								</ul>
							</div>
						</div>
						<div class="pcbpic">
							<img src="../../assets/image/pcb/pcb_pic.png" alt="">
						</div>
					</div>
					<div class="partfive_btn">
						<div @click="showCourse">
							<span>点击查看全部目录</span>
							<img src="../../assets/image/pcb/partfive_pic3.png" alt="">
						</div>
					</div>
				</div>
				<!--专家团队-->
				<div class="partsix">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_06.png" alt="">
					</div>
					<div class="partsixinfos partbox">
						<div class="partsixpic">
							<img src="../../assets/image/pcb/partsix_pic1.png" alt="">
						</div>
						<div id="">
							<div class="tab_content">
								<div v-show="cur==0">
									<div class="tab_content_child">
										<img src="../../assets/image/pcb/teabig_du.png">
										<p>
											20多年高速PCB设计、仿真经验。曾任港湾网络、一博科技、兴森快捷等高科技企业工程师、高级工程师、
											设计经理等职务，设计过的产品涵盖通信、医疗、工控、计算机、雷达、消费类等多个行业。<br>
											个人主要出版物：<br>
											《Cadence Allegro 实战攻略与高速PCB设计》
										</p>
									</div>
									<div class="teacher_con">
										<p class="teacher_name">杜正阔老师</p>
										<p class="teacher_title">
											EDA365 cadence allegro论坛特邀版主<br>
											原国内知名企业高速设计专家
										</p>
										<img class="twosimg_1" src="../../assets/image/pcb/tea_arrow.png" alt="">
									</div>
								</div>
								<div v-show="cur==1">
									<div class="tab_content_child">
										<img src="../../assets/image/pcb/teabig_peng.png" alt="">
										<p>
											10多年通讯设备PCB设计经验。在高速、高密度、数模混合电路等多类型PCB设计方面具备丰富的实战经验。
											在互连设计领域相关质量建设、效率提升及流程优化方面能力突出。
											曾获2010年度Mentor全球计算机PCB设计大赛金奖；2016年度IPC中国区PCB设计大赛冠军。
										</p>
									</div>
									<div class="teacher_con">
										<p class="teacher_name">彭水飞</p>
										<p class="teacher_title">
											EDA365Mentor Xpedition 论坛特邀版主<br>
											原中兴通讯互连设计专家
										</p>
										<img class="twosimg_2" src="../../assets/image/pcb/tea_arrow.png" alt="">
									</div>
								</div>
								<div v-show="cur==2">
									<div class="tab_content_child">
										<img src="../../assets/image/pcb/teabig_yan.png" alt="">
										<p>
											10多年专注通讯基站产品的单板工艺DFX设计和端到端交付，支持单板稳定交付数量达千万级。
											在产品研发阶段的可制造性设计、工艺可靠性设计、以及工艺设计流程和规范完善方面积累了丰富的经验。
											曾被评为华为金牌个人奖、总裁个人奖。
										</p>
									</div>
									<div class="teacher_con">
										<p class="teacher_name">严春美</p>
										<p class="teacher_title">
											EDA365论坛特邀版主<br>
											原华为研发工艺技术专家
										</p>
										<img class="twosimg_3" src="../../assets/image/pcb/tea_arrow.png" alt="">
									</div>
								</div>
							</div>
							<ul class="tab_tilte">
								<li class="tab_mod" @click="cur=0" :class="{active:cur==0}">
									<img class="tab_icon" src="../../assets/image/pcb/tea_du.jpeg" alt="" :class="{image1:cur != 0}">
									<img class="tab_icon" src="../../assets/image/pcb/tea_du.jpeg" alt="" :class="{image2:cur == 0}">
									<p class="teachers_name" :class="{tname:cur == 0}">杜正阔</p>
								</li>
								<li class="tab_mod" @click="cur=1" :class="{active:cur==1}">
									<img class="tab_icon" src="../../assets/image/pcb/tea_peng.jpeg" alt="" :class="{image1:cur != 1}">
									<img class="tab_icon" src="../../assets/image/pcb/tea_peng.jpeg" alt="" :class="{image2:cur == 1}">
									<p class="teachers_name" :class="{tname:cur == 1}">彭水飞</p>
								</li>
								<li class="tab_mod" @click="cur=2" :class="{active:cur==2}">
									<img class="tab_icon" src="../../assets/image/pcb/tea_yan.jpeg" alt="" :class="{image1:cur != 2}">
									<img class="tab_icon" src="../../assets/image/pcb/tea_yan.jpeg" alt="" :class="{image2:cur == 2}">
									<p class="teachers_name" :class="{tname:cur == 2}">严春美</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<!--用户好评-->
				<div class="partseven" v-show="partsevenShow">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_07.png" alt="">
					</div>
					<div class="swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide">
								<div class="user_name"><img src="../../assets/image/pcb/partseven_user1.png" alt=""><span>王工</span></div>
								<div>
									<p>我去年刚从大学毕业， 找工作的时候因为能力有限总是碰壁。我也知道如果我想要更好的发展，急需一些优质资源丰富自己，直到我看到这套《零经验，7天PCB设计实战从入门到进阶》，里面的教程非常详细，帮助我极大的提高了自身的职业素质。希望以后老师们可以多出几个这样的课程，谢谢老师！</p>
								</div>
							</div>
							<div class="swiper-slide">
								<div class="user_name"><img src="../../assets/image/pcb/partseven_user2.png" alt=""><span>李工</span></div>
								<div>
									<p>我是今年的电子厂实习 生，电路设计 是一个很复 杂过程，单靠个人 探索，始终没 有找到 正确的 学习方式。偶然我在 网上 看到了《零经验，7天PCB设 计实战从入门到进阶》，通过 系统的 学 习PCB设 计流程，令我茅塞顿开，像是打开 了电子工程进阶的大门，真的 非常谢谢这套视 频。</p>
								</div>
							</div>
							<div class="swiper-slide">
								<div class="user_name"><img src="../../assets/image/pcb/partseven_user3.png" alt=""><span>张工</span></div>
								<div>
									<p>做为一个从事PCB行业两年的“小菜鸟”，基础职位收入低也不是一年两年了，大家都想往技术方面深度发展，但一直没有机会深造。《零经验，7天PCB设计实战从入门到进阶》让我可以在下班之后抽出一点时学习，还能通过跟学老师的直播课练习PCB板的制作全流程，在我心里是非常优秀的一套课程。</p>
								</div>
							</div>
							<div class="swiper-slide">
								<div class="user_name"><img src="../../assets/image/pcb/partseven_user4.png" alt=""><span>吴工</span></div>
								<div>
									<p>我是一名普通的硬件入门级的工程师，之前有幸参与过电巢的直播课程，老师们的讲解很有意思，浅显易懂，很容易就将难点转化成自己的知识，之前就在想要是有系统地学习课程就好了。终于《零经验，7天PCB设计实战从入门到进阶》满足了我的需求，真的是我们这些硬件设计者的福音，万分期待……</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--报名流程-->
				<div class="parteight">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_08.png" alt="">
					</div>
					<div class="parteightinfos partbox">
						<div class="apply_process">
							<div>
								<img class="proicon" src="../../assets/image/pcb/parteight_pic1.png" alt="">
								<img class="proarrow" src="../../assets/image/pcb/parteight_pic5.png" alt="">
								<img class="proicon" src="../../assets/image/pcb/parteight_pic2.png" alt="">
								<img class="proarrow" src="../../assets/image/pcb/parteight_pic5.png" alt="">
								<img class="proicon" src="../../assets/image/pcb/parteight_pic3.png" alt="">
							</div>
							<div>
								<span>完成支付 <br> 报名成功</span>
								<span>识别二维码 <br> 添加助理</span>
								<span>开启PCB <br> 设计实践</span>
							</div>
						</div>
						<div class="apply_tips">
							<img src="../../assets/image/pcb/parteight_pic6.png" alt="">
							<span>请务必添加助理，才能开启权限。自报名日期起，有效期1年，请在有效期内完成体验。</span>
						</div>
					</div>
				</div>
				<!--往期精彩-->
				<div class="partnine">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_09.png" alt="">
					</div>
					<div class="partnineinfos partbox">
						<img src="../../assets/image/pcb/partnine_pic.png" alt="">
					</div>
				</div>
				<!--关于电巢-->
				<div class="partten">
					<div class="part_tit">
						<img src="../../assets/image/pcb/icon_10.png" alt="">
					</div>
					<div class="partteninfos partbox">
						<span>电巢是电子工程师的孵化巢，凝聚了一批来自高科技电子公司的资深主管和研发专家，结合旗下专业的电子工程师社区（www.EDA365.com），以专业的技术内容，汇聚行业优质资源，系统化地打造电子工程领域生态圈。</span>
						<span>电巢总部位于创新科技之都深圳，并在北京、上海、成都、西安、南京、武汉等均设有分支机构。</span>
					</div>
				</div>
			</div>
			<!--按钮-->
			<div class="footer_mod">
				<div class="down_btn">
					<div class="price">
						<p class="currentPrice">￥<span>{{ctivityCon.cash_price}}</span></p>
						<p class="originalCost"><s>￥{{ctivityCon.cash_origin_price}}</s> </p>
					</div>
					<div class="signUp_btn" @click="signUp">
						立即报名
					</div>
				</div>
			</div>
		</div>
		
		<!--弹出层-->
		<div class="courseshow" id="coursebox" @click="concealCourse" v-show="getCourse">
			<div class="courseinfo">
				<ul>
					<li>
						<div class="bigtit" id="closecourse">
							<p>入门带学</p>
							<p>x</p>
						</div>
						<div class="secondtit">
							<p>PCB设计基础</p>
						</div>
						<div class="secondinfo">
							<p><span>01</span><span>PCB设计术语与定义</span></p>
							<p><span>02</span><span>焊盘堆和过孔的构成及分类</span></p>
							<p><span>03</span><span>PCB主流设计工具</span></p>
							<p><span>04</span><span>PCB设计流程</span></p>
							<p><span>05</span><span>布局设计</span></p>
							<p><span>06</span><span>叠层设计</span></p>
							<p><span>07</span><span>布线设计原则和绕线设计</span></p>
							<p><span>08</span><span>PCB设计检查</span></p>
						</div>
					</li>
					<li>
						<div class="secondtit">
							<p>软件实操</p>
						</div>
						<div class="secondinfo">
							<p><span>01</span><span>OrCAD原理图基本操作</span></p>
							<ul>
								<li>如何打开OrCAD及其原理图</li>
								<li>如何建立元件符号封装</li>
								<li>如何修改原理图页面名称</li>
								<li>如何添加元件</li>
								<li>如何旋转和翻转元件</li>
								<li>如何绘制连线</li>
								<li>如何修改元件封装名</li>
								<li>如何检查原理图</li>
								<li>如何导出Allegro网表</li>
							</ul>
							<p><span>02</span><span>前处理</span></p>
							<ul>
								<li>如何打开Allegro并新建</li>
								<li>如何设置封装库路径</li>
								<li>如何导入结构图</li>
								<li>如何由结构图生成板框</li>
								<li>如何绘制允许布局布线区域</li>
								<li>如何导入第一方网表</li>
								<li>如何快速放置后台器件</li>
								<li>如何进行原理图与PCB交互布局</li>
								<li>如何按需要显示或隐藏飞线</li>
								<li>如何设置层面颜色和打开所需层面</li>
							</ul>
							<p><span>03</span><span>布局设计</span></p>
							<ul>
								<li>如何移动、旋转、镜像器件</li>
								<li>如何放置固定结构件</li>
								<li>如何锁定和解锁元器件</li>
								<li>如何高亮和取消高亮器件</li>
								<li>如何查找指定器件</li>
							</ul>
							<p><span>04</span><span>约束规则设置</span></p>
							<ul>
								<li>如何添加叠层</li>
								<li>如何添加或去除过孔</li>
								<li>如何创建Class </li>
								<li>如何设置线宽规则</li>
								<li>如何设置间距规则</li>
							</ul>
							<p><span>05</span><span>布线设计</span></p>
							<ul>
								<li>如何对BGA、SOP、QFN器件进行Fanout</li>
								<li>如何修改走线线宽</li>
								<li>如何打过孔</li>
								<li>如何在布线过程中变换走线角度</li>
								<li>如何在布线过程中变换走线节点</li>
								<li>如何移动走线和过孔</li>
								<li>如何删除走线和过孔</li>
								<li>如何复制过孔和走线</li>
								<li>如何高亮网络</li>
								<li>如何取消高亮网络</li>
								<li>如何查询网络信息</li>
								<li>如何查询走线信息</li>
								<li>如何测量走线、过孔间距</li>
							</ul>
							<p><span>06</span><span>铺铜处理</span></p>
							<ul>
								<li>如何铺铜箔</li>
								<li>如何修改铜箔外形</li>
								<li>如何修改铜箔网络名</li>
								<li>如何分割负片并灌铜</li>
							</ul>
							<p><span>07</span><span>后处理</span></p>
							<ul>
								<li>如何检查设计状态</li>
								<li>如何统计总Pin数、器件个数、布线完成率、布线密度</li>
								<li>如何修改字号大小</li>
								<li>如何修改器件位号大小</li>
								<li>如何调整丝印文字</li>
								<li>如何提取孔符图</li>
								<li>如何设置Gerber层</li>
								<li>如何输出Gerber</li>
								<li>如何设置钻孔参数</li>
								<li>如何输出钻孔文件</li>
								<li>如何输出零件坐标</li>
								<li>如何输出IPC网表</li>
							</ul>
							<p><span>08</span><span>SI 、PI验证与分析</span></p>
							<ul>
								<li>阻抗验证与分析</li>
								<li>耦合验证与分析</li>
							</ul>
						</div>
					</li>
					<li>
						<div class="secondtit">
							<p>高速PCB入门</p>
						</div>
						<div class="secondinfo">
							<p><span>01</span><span>无损传输线</span></p>
							<p><span>02</span><span>有损传输线（上）</span></p>
							<p><span>03</span><span>差分信号的概念</span></p>
							<p><span>04</span><span>高速PCB整体设计流程与思路</span></p>
							<p><span>05</span><span>DDR概述</span></p>
							<p><span>06</span><span> USB概述</span></p>
						</div>
					</li>
					<li>
						<div class="secondtit">
							<p>PCB设计生产流程</p>
						</div>
						<div class="secondinfo">
							<p><span>01</span><span>单板可制造性设计的概念</span></p>
							<p><span>02</span><span>PCB工艺</span></p>
						</div>
					</li>
					<li>
						<div class="bigtit">
							<p>进阶实操</p>
						</div>
						<div class="secondtit secondtits">
							<p>FPGA高速多层PCB设计实践</p>
						</div>
						<div class="secondinfo">
							<p><span>01</span><span>原理图解读及设计规划-兵马未动粮草先行</span></p>
							<p><span>02</span><span>布局思路与布局实战-思路决定出路</span></p>
							<p><span>03</span><span>高速约束规则制定与设置-国有国法，家有家规</span></p>
							<p><span>04</span><span>DDR模块设计实战-明知山有虎，偏向虎山行</span></p>
							<p><span>05</span><span>考虑SI、EMC的接口模块设计-打铁还需自身硬</span></p>
							<p><span>06</span><span>高速信号、电源仿真验证-大胆假设，小心求证</span></p>
							<p><span>07</span><span>设计高手养成记-路漫漫其修远兮</span></p>
						</div>
						<div class="pcbpics">
							<img src="../../assets/image/pcb/pcb_pic.png" alt="">
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper/swiper-bundle.min.js'
	import 'swiper/swiper-bundle.min.css'
	import {pagebase} from '@/utils/http.js';
	import utils from '@/utils/utils';
	import WxShare from '@/utils/wxshare'

	// 百度
	var _hmt = _hmt || [];
	(function() {
		var hm = document.createElement("script");
		hm.src = "https://hm.baidu.com/hm.js?24b8cea1e8cafdb512e2f597cf3fa8df";
		var s = document.getElementsByTagName("script")[0];
		s.parentNode.insertBefore(hm, s);
	})();

	export default {
		data() {
			return {
				aid: this.$route.query.aid || '',
				platform: this.$route.query.platform || '',
				pid: this.$route.query.pid || '',
				partsevenShow: false,
				cur: 0,
				ctivityCon: {},
				getCourse: false,
			}
		},
		mounted() {
			this.init();
			this.getSwiper();
		},
		methods: {
			init(){
				this.wxshare = new WxShare()
				if (this.platform == 1) {
					this.partsevenShow = false
				} else if (this.platform == 2) {
					this.partsevenShow = true
				}
				this.getactivityCon();
				this.showStat();
			},
			showStat() {
				this.$http({
					url: '/api/showStat',
					method: 'post',
					params: {
						url: window.location.href,
					}
				})
			},
			getactivityCon() {
				this.$http({
					url: '/activity/Info',
					method: 'get',
					params: {
						activity_id: this.aid,
					},
				}).then(res => {
					if (res.code >= 0) {
						let data = res.data;
						this.ctivityCon = data;
						document.title = data.title;
						this.wxshare.share({
							title: data.title,
							desc: data.summary,
							link: window.location.href,
							imgUrl: data.cover,
						})
					}
				})
			},
			getSwiper() {
				new Swiper(".swiper-container", {
					slidesPerView: "auto",
					// spaceBetween: 15,
					observer: true,
					observeParents: true,
				});
			},
			// 报名按钮
			signUp() {
				let succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.aid);
				let project = 'pcb'
				if (this.platform == 1) {
					project = encodeURIComponent('common?activity_id=200&platform=1')
				} else if (this.platform == 2) {
					project = encodeURIComponent('common?activity_id=200&platform=2')
				}
				if (utils.browserChecker.isWx()) {
					let channel = this.$route.query.channel || '';
					let open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.aid + '&project=' + project + '&pid=' + this.pid + 'channel=' + channel + '&succeed_url=' + succeedUrl);
					let url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
					window.location.href = url;
				} else {
					this.$router.push({
						path: '/payment',
						query: {
							activity_id: this.aid,
							channel: this.$route.query.channel || '',
							project: project,
							track_id: this.$route.query.track_id || '',
							succeed_url: succeedUrl,
							pid: this.pid,
						}
					})
				}
			},
			showCourse(){
				this.getCourse = true;
			},
			concealCourse(){
				this.getCourse = false;
			},
		}
	}
</script>

<style lang="css" scoped>
	.pcb {
		background: #010A4E;
	}

	.topbg img {
		width: 100%;
		display: block;
	}

	.content {
		padding: 5rem 1.5rem 9.5rem 1.5rem;
	}

	.partone,
	.parttwo,
	.partthree,
	.partfour,
	.partfive,
	.partsix,
	.partseven,
	.parteight,
	.partnine {
		margin-bottom: 3rem;
	}

	.part_tit {
		margin-bottom: 1.6rem;
	}

	.part_tit img {
		width: 100%;
	}

	.partbox {
		background: #FEFEFE;
		border-radius: 1rem;
	}

	.partoneinfos img {
		width: 100%;
	}

	.parttwoinfos {
		padding-top: 2.15rem;
	}

	.parttwoinfos ul li {
		padding-bottom: 3rem;
	}

	.parttwoinfos ul li:nth-child(odd) div.tit_words img {
		margin-right: 1rem;
	}

	.parttwoinfos ul li:nth-child(even) div.tit_words span {
		margin-right: 1rem;
		text-align: left;
	}

	.parttwoinfos ul li:nth-child(even) div.tit_img {
		text-align: right;
	}

	.tit_img {
		margin-bottom: 1.1rem;
	}

	.tit_img img {
		height: 3.2rem;
		width: auto;
	}

	.tit_words {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 1.4rem;
	}

	.tit_words img {
		height: 9.6rem;
	}

	.tit_words span {
		color: #2F51B1;
		font-size: 1.3rem;
		line-height: 1.8rem;
	}

	.partthreeinfos {
		display: flex;
		justify-content: flex-start;
		padding: 0 1.3rem 3rem 1.3rem;
	}

	.partthree_left {
		display: flex;
		align-items: center;
	}

	.partthree_left img {
		width: 14.3rem;
	}

	.partthree_right {
		margin-top: 3rem;
	}

	.threeright_info {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 2.6rem;
	}

	.threeright_info:first-child {
		margin-left: -5rem;
	}

	.threeright_info:nth-child(2) {
		margin-left: .8rem;
	}

	.threeright_info:last-child {
		margin: 0 0 0 -5rem;
	}

	.threeright_info em {
		font-style: normal;
		font-size: 3rem;
		line-height: 1.6rem;
		color: #3353D8;
		display: block;
		margin-right: .85rem;
		font-weight: 200;
	}

	.threeright_info span {
		color: #0B2581;
		font-size: 2rem;
		line-height: 2.8rem;
		font-weight: 600;
	}

	.threeright_info p {
		color: #2F51B1;
		font-size: 1.3rem;
		line-height: 1.8rem;
	}

	.partfourinfos {
		padding: 2rem 1.8rem;
	}

	.partfourinfos img {
		width: 100%;
		margin-bottom: 1.1rem;
	}

	.partfiveinfos {
		padding: 2rem .9rem;
	}

	.partfive_box {
		display: flex;
		padding-bottom: .65rem;
		background-image: url("../../assets/image/pcb/partfive_pic2.png");
		background-repeat: no-repeat;
		background-position: 3% 0;
		background-size: .15rem 100%;
	}

	.partfive_box:last-child {
		padding-bottom: 0;
	}

	.partfive_box div:first-child {
		margin-right: 1.35rem;
	}

	.partfive_box div:last-child {
		width: 100%;
	}

	.partfive_box img {
		width: 1.75rem;
		background: #fff;
	}

	.pcbpic {
		display: flex;
		justify-content: center;
		margin-top: 2rem;
	}

	.pcbpic img {
		width: 22rem;
	}

	.pcbpics {
		display: flex;
		justify-content: center;
		margin-bottom: 2rem;
	}

	.pcbpics img {
		width: 22rem;
	}

	.partfive_box p {
		color: #3353D8;
		font-size: 2rem;
		line-height: 2.5rem;
		font-weight: 600;
		margin-top: .6rem;
	}

	.partfive_box span {
		font-size: 1.6rem;
		color: #3353D8;
		margin-top: .5rem;
		display: block;
	}

	.partfive_box ul {
		margin-top: .95rem;
	}

	.partfive_box ul li {
		color: #8FA1D7;
		font-size: 1.4rem;
		line-height: 2rem;
	}

	.partfive_box ul li span {
		color: #8D7FAA;
		font-size: 1.4rem;
		line-height: 2rem;
	}

	.partfive_box ul li i {
		background: #8FA1D7;
		width: .5rem;
		height: .5rem;
		border-radius: 50%;
		margin-right: .75rem;
		display: inline-block;
		margin-bottom: .3rem;
	}

	.partfive_box h4 {
		color: #fff;
		font-size: 1.2rem;
		background: #9F74F7;
		display: block;
		padding: .3rem .6rem;
		margin-top: .8rem;
		line-height: 2rem;
	}

	.partfive_btn {
		margin-top: .85rem;
	}

	.partfive_btn>div {
		background: #05F4A1;
		border-radius: 1.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: .5rem 0;
		width: 20rem;
		margin: 0 auto;
	}

	.partfive_btn>div span {
		color: #010A4E;
		font-size: 1.4rem;
		line-height: 2rem;
	}

	.partfive_btn>div img {
		width: 1.8rem;
	}

	.partsixinfos {
		padding: 3rem 1.5rem 2rem 1.5rem;
	}

	.partsixpic img {
		width: 100%;
	}

	.tab_tilte {
		margin-top: 1.85rem;
		width: 100%;
		height: 7rem;
		display: flex;
		justify-content: space-between;
	}

	.tab_mod {
		position: relative;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		align-items: center;
	}

	.tab_mod {
		font-size: 1.2rem;
	}

	.tab_icon {
		display: none;
	}
	
	.teachers_name{
		color: #080943;
	}
	
	.tname{
		color: #0A2480;
	}

	.image1 {
		position: relative;
		display: block;
		width: 4.6rem;
		height: 4.6rem;
		border-radius: 50%;
		opacity: 0.5;
		z-index: 2;
	}

	.image2 {
		position: relative;
		display: block;
		width: 4.6rem;
		height: 4.6rem;
		border-radius: 50%;
		z-index: 2;
	}

	.tab_content {
		margin-top: 2.2rem;
		height: 25rem;
		box-sizing: border-box;
	}

	.tab_content_child {
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		padding: 0 1rem;
		background-color: #F4FAFF;
		border-radius: .6rem .6rem 0 0;
	}

	.tab_content_child img {
		width: 10.8rem;
		height: 15.9rem;
	}

	.tab_content_child p {
		padding-top: 1.5rem;
		width: 18.2rem;
		height: 17rem;
		font-size: 1.1rem;
		color: #0A2480;
	}

	.teacher_con {
		position: relative;
		height: 6.4rem;
		background-color: #3353D8;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 1.85rem;
		border-radius: 0 0 .6rem .6rem;
	}

	.teacher_name {
		font-size: 1.4rem;
		color: #FEFEFE;
	}

	.teacher_title {
		font-size: 1rem;
		color: #FEFEFE;
	}

	.twosimg_1 {
		position: absolute;
		left: 1.5rem;
		bottom: -1.5rem;
		z-index: 10;
		width: 1.5rem;
		height: 1.5rem;
	}

	.twosimg_2 {
		position: absolute;
		left: 15rem;
		bottom: -1.5rem;
		z-index: 10;
		width: 1.5rem;
		height: 1.5rem;
	}

	.twosimg_3 {
		position: absolute;
		left: 28.3rem;
		bottom: -1.5rem;
		z-index: 10;
		width: 1.5rem;
		height: 1.5rem;
	}

	/*�û�����*/
	.partseveninfos {
		padding: 2rem 1rem;
		overflow-x: auto;
		white-space: nowrap;
	}

	.partseveninfos::-webkit-scrollbar {
		display: none;
	}

	/* 轮播 */
	.swiper-container {
		box-sizing: border-box;
		padding: 2rem;
		width: 100%;
		height: 100%;
		background-color: #FEFEFE;
		overflow: hidden;
		border-radius: 1rem;
	}

	.swiper-wrapper {
		display: flex;
		justify-content: flex-start;
	}

	.swiper-slide {
		width: 28rem;
		height: 19rem;
		background: #EAF3FA;
		border-radius: .4rem;
		padding: 1.1rem 1.6rem 1.9rem 1.2rem;
		margin-right: 1rem;
		box-sizing: border-box;
	}
	
	.user_name{
		display: flex;
		align-items: center;
		font-size: 1.4rem;
		color: #010A4E;
	}
	.user_name span{
		margin-left: 1rem;
	}

	.swiper-slide img {
		width: 4.5rem;
		height: 4.5rem;
		border-radius: 50%;
	}
	
	.swiper-slide p{
		font-size: 1.2rem;
		margin-top: 1rem;
	}

	/*报名流程*/
	.apply_process {
		padding: 2.5rem 1.5rem 1.8rem 1.5rem;
	}

	.apply_process>div {
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.apply_process>div:last-child {
		padding: 0 1rem;
	}

	.apply_process img.proicon {
		width: 22%;
	}

	.apply_process img.proarrow {
		width: 2.5rem;
		height: 2.5rem;
	}

	.apply_process span {
		color: #6753D5;
		font-size: 1.3rem;
		font-weight: 600;
		line-height: 2rem;
	}

	.apply_tips {
		padding: 20px 10px;
	}

	.apply_tips img {
		width: 100%;
	}

	.apply_tips span {
		color: #3235A1;
		font-size: 1.2rem;
		line-height: 1.6rem;
		padding: 0 .4rem;
		display: block;
	}

	/*往期精彩*/
	.partnineinfos {
		padding: 1.3rem;
	}

	.partnineinfos img {
		width: 100%;
		display: block;
	}

	/*关于电巢*/
	.partteninfos {
		padding: 1.8rem 1.7rem;
	}

	.partteninfos span {
		color: #2F51B1;
		font-size: 1.4rem;
		line-height: 2rem;
		display: block;
	}

	.partteninfos span:last-child {
		margin-top: 1rem;
	}

	/*报名按钮*/
	.footer_mod {
		position: fixed;
		align-items: center;
		left: 0;
		bottom: 0;
		box-sizing: border-box;
		width: 100%;
		z-index: 5;
	}
	
	.down_btn {
		box-sizing: border-box;
		width: 100%;
		background-color: #5F60F6;
		z-index: 50;
		justify-content: center;
		display: flex;
		justify-content: space-between;
		padding: .8rem 1.4rem;
		color: #FFF;
	}
	
	.price {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.originalCost {
		margin-top: 1rem;
		margin-left: 1rem;
		color: #DDD;
		font-size: 1.2rem;
	}
	
	.currentPrice {
		font-size: 1.4rem;
	}
	
	.currentPrice span {
		font-size: 2.8rem;
		font-weight: normal;
		color: #F9F9F9;
	}
	
	.signUp_btn {
		box-sizing: border-box;
		text-align: center;
		width: 18.1rem;
		height: 4.4rem;
		line-height: 4.4rem;
		font-size: 1.8rem;
		font-weight: 600;
		color: #1F3364;
		background-color: #F9D346;
		border-radius: 2.2rem;
	}

	/*弹出框*/
	.courseshow {
		height: 100%;
		box-sizing: border-box;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		overflow: auto;
		z-index: 20;
	}

	.courseinfo {
		box-sizing: border-box;
		position: absolute;
		width: 32rem;
		height: 60rem;
		top: 50%;
		left: 50%;
		margin-left: -16rem;
		margin-top: -30rem;
		overflow: auto;
		background-color: #fff;
	}

	.bigtit {
		background-color: #010A4E;
		color: #FFFFFF;
		font-size: 1.8rem;
		padding: .7rem .5rem .7rem 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: .3rem;
	}

	.secondtit {
		background: #3353D8;
		color: #FFFFFF;
		font-size: 1.4rem;
		padding: .4rem .4rem .4rem 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.secondtits {
		margin-top: .1rem;
	}

	.secondinfo {
		padding: 1.4rem 1.2rem;
	}

	.secondinfo p {
		margin-top: .3rem;
		font-size: 1.2rem;
		color: #0A2480;
	}

	.secondinfo p span:last-child {
		padding-left: 1.4rem;
	}

	.secondinfo ul li {
		color: #4765D0;
		font-size: 1.1rem;
		margin: .4rem 0 .4rem 4.4rem;
		list-style: disc;
	}
	
	/* 咨询 */
	.consult_alert {
		z-index: 5;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
	}
	
	.consult_alert_con {
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -14rem;
		margin-left: -14rem;
		width: 28rem;
		height: 28rem;
		background-color: #F3F7FC;
		border-radius: 1rem;
	}
	
	.consult_alert_ma {
		height: 100%;
		display: flex;
		font-size: 1.8rem;
		font-weight: 600;
		color: #080943;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.consult_alert_ma img {
		width: 15rem;
		height: 15rem;
	}
	
	.consult_close_btn {
		margin-top: .5rem;
		display: flex;
		justify-content: center;
	}
	
	.consult_close_btn img {
		width: 3.8rem;
		height: 3.8rem;
	}
	
	@media (min-width: 751px) {
		.courseshow {
			width: 750px;
			left: 50%;
			margin-left: -375px;
		}
	
		.courseinfo {
			box-sizing: border-box;
			position: absolute;
			width: 32rem;
			height: 800px;
			top: 50%;
			left: 50%;
			margin-left: -16rem;
			margin-top: -440px;
			overflow: auto;
		}
		
		.footer_mod {
			width: 750px;
			left: 50%;
			margin-left: -375px;
		}
	}
</style>
